import { parse, stringify } from 'jsurl'
import type { AnywhereThemeOverride } from '@wix/thunderbolt-ssr-api'

export type ColorOverrides = AnywhereThemeOverride['colorOverrides']
export type TextOverrides = AnywhereThemeOverride['textOverrides']

export const stringifyThemeOverrides = (themeOverrides: AnywhereThemeOverride): string => {
	return stringify(themeOverrides)
}

export const parseThemeOverrides = (stringifiedThemeOverrides: string): AnywhereThemeOverride => {
	return parse(stringifiedThemeOverrides)
}
